import { createSelector } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";
import { clearSecretaryOrgRequestsCache, clearSecretaryRequestsCache, setMoreOrgRequests, setMoreRequests, setOrgRequests, setRequests } from "../states/secretaryState";




export const requestApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getRequestsData: builder.query({
        query: () => '/requests/requests-data/',
        providesTags: ['RequestsData'],
    }),
    getUserRequests: builder.query({
        query: () => '/requests/user-requests/',
        providesTags: ['UserRequests'],
    }),
    getAllRequests: builder.query({
        query: ({month, year,query,user_type,crQuery}) => `/requests/all-requests/?month=${month}&year=${year}&query=${query}&crQuery=${crQuery}&user_type=${user_type}`,
        providesTags: ['Requests'],
        async onQueryStarted( {user_type}, { dispatch, queryFulfilled }) {
          try {
            console.log(user_type)
            const { data } = await queryFulfilled
            if(user_type === 'organization') {
              dispatch(setOrgRequests(data))
            } else {
  
              dispatch(setRequests(data))
            }
            
          } catch (err) {
            console.error('Failed to add item', err)
          }
        }
      }),
    getMoreRequests: builder.query({
      query: ({year,month,page,query,user_type,crQuery}) => `/requests/all-requests/?month=${month}&year=${year}&page=${page}&query=${query}&crQuery=${crQuery}&user_type=${user_type}`,
      async onQueryStarted( {user_type}, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if(user_type === 'organization') {
            dispatch(setMoreOrgRequests(data))
          } else {

            dispatch(setMoreRequests(data))
          }
        } catch (err) {
          console.error('Failed to add item', err)
        }
      }
    }),
    getRequestsByStatus: builder.query({
      query: ({status, user_type}) => `/requests/requests-by-ststus/${status}/?user_type=${user_type}`,
      providesTags: ['Requests'],
    }),
    createRequest: builder.mutation({
      query: (requestObj) => ({
        url: `/requests/user-requests/`,
        method: 'POST',
        body: requestObj
      }),
      invalidatesTags: ['UserRequests'],
    }),
    handleRequest: builder.mutation({
      query: (decisionObj) => ({
        url: `/requests/handle-request/`,
        method: 'PATCH',
        body: decisionObj
      }),
      invalidatesTags: ['Requests', 'RequestsData'],
      async onQueryStarted( requests, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(clearSecretaryRequestsCache())
          dispatch(clearSecretaryOrgRequestsCache())
        } catch (err) {
          console.error('Failed to add item', err)
        }
      }
    }),
    changeSetting: builder.mutation({
      query: (settingObj) => ({
        url: `/requests/change-settings/`,
        method: 'PATCH',
        body: settingObj
      })
    }),

  })
})

export const selectUserRequestsResult = apiSlice.endpoints.getUserRequests.select()

export const selectUserRequestsData = createSelector(
  selectUserRequestsResult,
  result => result?.data ?? null
)

export const { 
    useGetRequestsDataQuery,
    useGetUserRequestsQuery,
    useGetRequestsByStatusQuery,
    useLazyGetAllRequestsQuery,
    useLazyGetMoreRequestsQuery,
    useCreateRequestMutation,
    useHandleRequestMutation,
    useChangeSettingMutation,
 } = requestApiSlice;